import { render, staticRenderFns } from "./export-from-json.vue?vue&type=template&id=7118ab01&"
import script from "./export-from-json.component.ts?vue&type=script&lang=ts&"
export * from "./export-from-json.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports